import * as LabelPrimitive from '@radix-ui/react-label';
import cn from '~/utils/cn';
import { cva } from 'class-variance-authority';
import * as React from 'react';

const labelVariants = cva(
    'tw-text-sm tw-font-medium tw-leading-none peer-disabled:tw-cursor-not-allowed peer-disabled:tw-opacity-70'
);

const Label = React.forwardRef(({ className, ...props }, ref) => (
    <LabelPrimitive.Root className={cn(labelVariants(), className)} ref={ref} {...props}/>
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
